class StickySearchBar {
  static async init () {
    return new StickySearchBar()
  }

  constructor () {
    const $searchBar = $('.sticky-search')
    const parentWidth = $searchBar.parent().width()

    if ($searchBar[0]) {
      const searchBarOffset = $searchBar.offset().top

      document.addEventListener('scroll', () => {
        if (window.pageYOffset >= searchBarOffset) {
          $searchBar.addClass('sticky-section')
          $searchBar.width(parentWidth)
          $searchBar.addClass('sticky-box-shadow')
          $('.listings-index__outer').css('padding-top', Math.round($searchBar.height()))
        } else {
          $searchBar.removeClass('sticky-section')
          $searchBar.removeClass('sticky-box-shadow')
          $('.listings-index__outer').css('padding-top', 0)
        }
      })
    }
  }
}
export default StickySearchBar
